import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AddonCollection as SchemaAddonCollection } from '../schemas/AddonCollection';
import { type AddonSortField as SchemaAddonSortField } from '../schemas/AddonSortField';
import { type SortOrder as SchemaSortOrder } from '../schemas/SortOrder';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Returns the full list of all store addons
 * @tags Addons
 * @summary Get list of addons
 */
export const AddonListContentType = '' as const;
export type AddonListRequest = void;
export type AddonListResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful operation
     */
    '200': {
        'application/json': SchemaAddonCollection;
    };
};
export type AddonListResponseSuccess = AddonListResponses['200']['application/json'];
export type AddonListSearchParams = {
    search?: string;
    sort_field?: SchemaAddonSortField;
    sort_direction?: SchemaSortOrder;
};
export type AddonListPathParameters = undefined;
export const AddonListUrl = '/addons' as const;
export const AddonListMethod = 'GET' as const;
export const getAddonListUrl = (_params?: AddonListPathParameters) => AddonListUrl;
